import React from 'react';
import { createRoot } from 'react-dom/client';
import { SuperSelect } from '../../component/superSelect/SuperSelect';
import Client from '../../model/api/Client';

const elements = document.getElementsByClassName('header-search');

for (let i = 0; i < elements.length; i++) {
	const element = elements[i];
	const rootElement = document.createElement('div');
	element.parentElement.prepend(rootElement);
	const root = createRoot(rootElement);
	const client = new Client();
	root.render(
		<SuperSelect
			originalInputId={element.id}
			defaultValue={element.value}
			wrapperConfig={{
				className: 'me-2'
			}}
			inputConfig={{
				className: element.classList,
				placeholder: element.placeholder
			}}
			onSearch={(search, setList) =>
				search === ''
					? setList([])
					: client
							.companySearch(search, 10)
							.then((response) => (response !== null ? setList(response.result) : null))
			}
			formatItem={(item) => (
				<a className="dropdown-item" href={item.url}>
					{item.name}
				</a>
			)}
		/>
	);
}
